module.exports = __webpack_public_path__ + "static/attendees-d565ed943a32cea88c265134dc55c1df.jpg";